<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="paddingContent">
      <ActivityDraw />
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import ActivityDraw from "@/components/activityDraw.vue";
export default {
  data() {
    return {
      navBlock: "活動 / 活動列表 ",
      navtitle: "活動抽簽"
    };
  },
  created() {},

  destroyed() {},
  
  methods: {
    //徽章处理
  },
  components: {
    NavBar,
    ActivityDraw
  }
};
</script>

<style lang="less" scoped>
.content {
  background-color: rgba(245, 245, 252, 1);
  .paddingContent {
    width: 100%;
    // overflow: auto;
    display: flex;
  }
}
@media screen and (min-width: 769px) {
  .paddingContent {
    min-width: 1210px;
  }
}
@media screen and (max-width: 769px) {
  .paddingContent {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activityDrawList.vue